<template>
    <div v-if="logs != null && logs.length > 0" class="activitylog">
        <v-row class="mx-0">
            <v-col class="col-sm-6 col-6 pa-0 mb-3 d-flex align-center">
                <div v-for="tab in tabs" :key="tab.value" :class="['global-label mr-5', selectedTab === tab.value ? 'underline' : '']">
                    <a href="javascript:" @click="selectedTab = tab.value">{{ tab.name }}</a>
                </div>
            </v-col>
            <v-col class="global-label col-6 text-right py-0 pl-0 pr-3">
                <a href="javascript:" @click="toggleSortBy()">{{ sortBy.name }}</a>
            </v-col>
        </v-row>
        <v-row no-gutters :class="isFullPage ? 'ml-3' : ''">
            <v-col v-for="(item, index) in sortedLogs" :key="index" cols="12" class="mb-4">
                <CommentRow
                    v-if="isRowComment(item.type) && selectedTab === TASK_INFO_TABS().COMMUNICATION.value"
                    :task-id="taskId"
                    :item="item"
                    @reply="$emit('reply', $event)"
                />
                <EmailLogRow
                    v-else-if="item.type === 'email_log' && selectedTab === TASK_INFO_TABS().COMMUNICATION.value"
                    :item="item"
                />
                <EmailRow
                    v-else-if="isRowEmail(item.type) && selectedTab === TASK_INFO_TABS().ACTIVITY.value"
                    :item="item"
                />
                <ActivityRow
                    v-else-if="selectedTab === TASK_INFO_TABS().ACTIVITY.value"
                    :item="item"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import CommentRow from "./Rows/CommentRow";
import EmailRow from "./Rows/EmailRow";
import ActivityRow from "./Rows/ActivityRow";
import {TASK_LOG_TYPE, TASK_INFO_TABS, TASK_INFO_SORT_BY} from "../../../helpers/constants";
import {computed, ref, watch} from "@vue/composition-api";
import EmailLogRow from "@/views/Task/TaskInfoList/Rows/EmailLogRow";
import ApiTaskUnseenEmail from "@/api/task/taskUnseenEmails"

export default {
    name: "TaskActivityList",
    components: {
        CommentRow,
        EmailRow,
        ActivityRow,
        EmailLogRow
    },
    props: {
        taskId: {
            type: [String, Number],
            required: true
        },
        accountId: {
            type: Number,
            required: true
        },
        logs: {
            type: Array,
            default: null
        },
        isFullPage: {
            type: Boolean,
            default: false
        },
        tasksList: {
            type: Array,
            default: null
        },
    },

    setup(props) {
        const selectedTab = ref(null)
        const sortBy = ref(TASK_INFO_SORT_BY().OLDEST)

        const isRowComment = type => {
            return [
                TASK_LOG_TYPE.TASK_COMMENT,
                TASK_LOG_TYPE.TASK_MESSAGE,
                TASK_LOG_TYPE.TASK_MESSAGE_FROM_EMAIL,
                TASK_LOG_TYPE.TASK_INCOMING_EMAIL,
                TASK_LOG_TYPE.TASK_MESSAGE_FROM_PROJECT_EMAIL,
                TASK_LOG_TYPE.TASK_MESSAGE_FROM_CLIENT_EMAIL
            ].includes(type)
        };

        const isRowEmail = type => {
            return [
                TASK_LOG_TYPE.TASK_EMAIL_ADDED,
                TASK_LOG_TYPE.TASK_EMAIL_CHANGED,
                TASK_LOG_TYPE.TASK_EMAIL_DELETED,
                TASK_LOG_TYPE.TASK_EMAIL_SEND_SUCCESS,
                TASK_LOG_TYPE.TASK_EMAIL_SEND_FAILED
            ].includes(type)
        }

        const isRowCommunicationEmail = type => {
            return [
                TASK_LOG_TYPE.TASK_EMAIL_SEND_SUCCESS,
                TASK_LOG_TYPE.TASK_EMAIL_SEND_FAILED
            ].includes(type)
        }

        const showCommunicationTab = computed(() => Boolean(props.logs.find(x => isRowComment(x.type) || isRowCommunicationEmail(x.type) || x.type === 'email_log')))
        const showActivityTab = computed(() => Boolean(props.logs.find(x => !(isRowComment(x.type) && isRowCommunicationEmail(x.type)))))

        const tabs = computed(() => {
            let value = []

            if (showCommunicationTab.value) {
                value.push(TASK_INFO_TABS().COMMUNICATION)
            }

            if (showActivityTab.value) {
                value.push(TASK_INFO_TABS().ACTIVITY)
            }

            return value
        })

        const sortedLogs = computed(() => {
            let logs = [...props.logs]
            if (selectedTab.value === TASK_INFO_TABS().COMMUNICATION.value) {
                logs = logs.filter(x => isRowComment(x.type) || isRowCommunicationEmail(x.type) || x.type === 'email_log')
            } else {
                logs = logs.filter(x => !(isRowComment(x.type) || isRowCommunicationEmail(x.type) || x.type === 'email_log'))
            }

            logs.sort((a, b) => {
                if (sortBy.value.value === TASK_INFO_SORT_BY().NEWEST.value) {
                    return new Date(b.created_at) - new Date(a.created_at)
                } else {
                    return new Date(a.created_at) - new Date(b.created_at)
                }
            })

            return logs
        })

        watch(() => props.logs, () => {
            selectedTab.value = tabs.value.length ? tabs.value[0].value : null
        })

        const toggleSortBy = () => {
            sortBy.value = TASK_INFO_SORT_BY().OLDEST.value === sortBy.value.value ? TASK_INFO_SORT_BY().NEWEST : TASK_INFO_SORT_BY().OLDEST
        }

        const initialize = () => {
            try {
                if (props.taskId && props.logs && props.logs.length && showCommunicationTab.value) {
                    // mark task messages seen (if any)
                    ApiTaskUnseenEmail.markTaskNotificationsSeen(props.taskId)

                    if (props.tasksList) {
                        // refresh task in list (if any)
                        const taskIndex = props.tasksList.findIndex(x => x.id === props.taskId)
                        if (taskIndex >= 0) {
                            props.tasksList[taskIndex].unread_public_messages = 0
                            props.tasksList[taskIndex].unread_internal_comments = 0
                        }
                    }
                }
            } catch (e) {
                console.error('mark task messages seen', e)
            }
        };
        initialize()

        return {
            isRowEmail,
            isRowComment,
            selectedTab,
            TASK_INFO_TABS,
            showCommunicationTab,
            showActivityTab,
            tabs,
            sortBy,
            toggleSortBy,
            sortedLogs
        };
    }
};
</script>
